
export function getAllHistoryItems(state) {
  return state.getIn(["school_money", "history"]);
}

export function getHistoryItemsByType(state, type) {
  return state.getIn(["school_money", "history", type]);
}

function getSortByFieldByHistoryType(historyType) {
  switch (historyType) {
    case "payment" : return "paidDate";
    case "dinner"  : return "startDate";
    case "club"    : return "startDate";
    case "meal"    : return "date";
    default        : return "id";
  }
}

/**
 * @returns {Immutable.List}
 */
export function getHistoryItemList(state, type, studentID) {
      // we sort on a different property for each history type
  const sortByField = getSortByFieldByHistoryType(type);

  
  return state.getIn(["school_money", "history", type])
    .filter(historyItem => historyItem.get("studentID") === studentID)
    .sortBy(historyItem => historyItem.get(sortByField) )
    .valueSeq().toList();
}

/**
 * @returns {boolean}
 */
export function isHistoryReady(state, studentID) {
  return !state.getIn(["school_money", "isHistoryLoading"]);
}



// WEBPACK FOOTER //
// ./src/state/school_money/selectors/history.js